import { faClock, faTicket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const WorkSummaryPerPerson = ({ data }) => {
  const getEfficiencyColor = (efficiency) => {
    switch (efficiency) {
      case "high":
        return "#22c55e";
      case "medium":
        return "#f59e0b";
      case "low":
        return "#ef4444";
      default:
        return "#6b7280";
    }
  };

  return (
    <div className="p-6">
      {/* Person Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {data.map((person, index) => (
          <div
            key={index}
            className="bg-gray-50 rounded-lg p-4 hover:shadow-md transition-all duration-300 border border-gray-100"
          >
            {/* Person Header */}
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-2">
                <div
                  className="w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-semibold"
                  style={{ backgroundColor: "#144677" }}
                >
                  {person.name
                    .split(" ")
                    .map((n) => n[0])
                    .join("")}
                </div>
                <h4
                  className="font-semibold text-sm"
                  style={{ color: "#144677" }}
                >
                  {person.name}
                </h4>
              </div>

              {/* Efficiency Badge */}
              {/* <div
                className="px-2 py-1 rounded-full text-xs font-medium capitalize"
                style={{
                  backgroundColor: getEfficiencyBg(person.efficiency),
                  color: getEfficiencyColor(person.efficiency),
                }}
              >
                {person.efficiency}
              </div> */}
            </div>

            {/* Metrics */}
            <div className="space-y-3">
              {/* Tickets */}
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <FontAwesomeIcon
                    icon={faTicket}
                    size={16}
                    style={{ color: "#FF6266" }}
                  />
                  <span className="text-sm text-gray-600">Tickets</span>
                </div>
                <span
                  className="font-semibold text-sm"
                  style={{ color: "#144677" }}
                >
                  {person.tickets}
                </span>
              </div>

              {/* Hours */}
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <FontAwesomeIcon
                    icon={faClock}
                    size={16}
                    style={{ color: "#1a5c99" }}
                  />
                  <span className="text-sm text-gray-600">Hours</span>
                </div>
                <span
                  className="font-semibold text-sm"
                  style={{ color: "#144677" }}
                >
                  {person.hours}h
                </span>
              </div>

              {/* Tickets per Hour */}
              <div className="pt-2 border-t border-gray-200">
                <div className="flex items-center justify-between">
                  <span className="text-xs text-gray-500">Hour/Ticket</span>
                  <span
                    className="text-sm font-bold"
                    style={{ color: getEfficiencyColor(person.efficiency) }}
                  >
                    {(person.hours / person.tickets).toFixed(2)} hrs/ticket
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkSummaryPerPerson;
